import * as React from 'react';
import classnames from 'classnames';
import s from './PaymentMethodLogo.scss';
export const PaymentMethodLogo = ({ cardBrand, className = '', }) => {
    return (React.createElement("div", { "data-hook": "payment-method-logo", "data-attrs": `cardBrand-${cardBrand}`, className: classnames(s[cardBrand], className) }));
};
//# sourceMappingURL=PaymentMethodLogo.js.map